<template>
  <div class="calculator-container">
      <div class="flex shadow-btn" @click="openCalculator">
        <svg-icon class-name="calculator" icon-class="calculator" />计算器
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      memberInfo: {},
      showActivity: false,
    }
  },
  computed: {
    ...mapGetters([
      'appCode',
    ]),
  },
  mounted() {
  },
  methods: {
    openCalculator() {
      let url = 'http://h5.saas.taxll.com/calculator'
      if (this.appCode.includes('YY00011')) {
        url += '?showOfficialWebsite=true'
      }
      // 宽600高700弹窗居中打开
      window.open(url, '工资&个税计算器', 'width=600,height=700')
    },
  },
}
</script>
<style scoped lang="scss">
.calculator-container {
  height: 100%;
  display: flex;
  align-items: center;
}

@keyframes slideBright {
  0% {
    left: 0;
  }

  30% {
    left: 100%;
  }

  100% {
    left: 100%;
  }
}

.slideBright {
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 15px;
    height: 100%;
    transform: rotate(-45deg);
    background: linear-gradient(to right, transparent, #fff, transparent);
    animation: slideBright 3s ease-in-out infinite;
  }
}

.shadow-btn {
  border-radius: 5px;
  font-weight: bold;
  font-size: 12px;
  height: 70%;
  cursor: pointer;
  padding: 0 10px;
  justify-content: space-between;
}

.flex {
  display: flex;
  align-items: center;
  gap: 5px;
}

.calculator {
  font-size: 20px;
}
</style>

